import { render, staticRenderFns } from "./checkbox-picker.vue?vue&type=template&id=b5028ff2&"
import script from "./checkbox-picker.vue?vue&type=script&lang=js&"
export * from "./checkbox-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "checkbox-picker.vue"
export default component.exports